<template>
  <div :class="['layer-popup-wrap', isOpen ? 'open' : '']">
    <div class="layer-popup" tabindex="0">
      <h4 class="pop-tit">주석</h4>
      <div class="pop-cont">
          <p class="remark" style="white-space: pre-wrap;">{{cmmtDesc}}</p>
      </div>
        <button type="button" class="btn-pop-close" @click="close"><span class="hidden">닫기</span></button>
    </div>
  </div>
</template>

<script>
export default {
  name: "DownLoadPopup",
  props: {
    cmmtDesc: {
      type: String
    }
  },
  data() {
    return {
      isOpen: false,
      popBtn: ''
    }
  },
  computed: {
    /*description() { // v-html 사용하지 않고 처리
      return this.cmmtDesc.replace("\n", "</br>");
    }*/
  },
  methods: {
    reset() {
    },

    open(evt) {
      this.reset();
      this.isOpen = true;

      // 웹접근성 레이어 팝업 키보드 초점
      this.popBtn = evt.target
      setTimeout(() => {
        const popup = this.$parent.$refs.comDescPopup.$el
        popup.firstChild.focus()
      }, 300);
    },

    close() {
      this.isOpen = false;

      // 웹접근성 레이어 팝업 키보드 초점
      this.popBtn.focus()
    },
  },

}
</script>
